import classes from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/Common/AssociatedDocuments/components/addLinkToFile/AddLinkToFile.module.scss';
import { isValidUrl } from 'utilitys/helpers/general';
import { CustomizedButton, CustomizedFormErrorMessage } from 'components/common';
import TextSearchInput from 'components/common/TextSearchInput/textSearchInput';
import { Control, Controller, FieldErrors, UseFormSetValue } from 'react-hook-form';
import { IFields } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/Common/AssociatedDocuments/components/addAssociatedDocuments/addAssociatedDocuments';

interface Props {
    control: Control<IFields, any, IFields>;
    handleCancel: () => void;
    errors: FieldErrors<IFields>;
    setValue: UseFormSetValue<IFields>;
}

export const AddLinkToFile = ({ control, handleCancel, setValue, errors }: Props) => {
    return (
        <div className={classes.addLinkToFileWrapper}>
            <div className={classes.inputsWrapper}>
                <div>
                    <div className={classes.inputTitle}>External Link Title</div>

                    <Controller
                        render={({ field }) => (
                            <TextSearchInput
                                {...field}
                                isSearch={false}
                                placeholder=""
                                maxLength={50}
                                handleClear={() => {
                                    setValue('externalLink.title', '');
                                }}
                            />
                        )}
                        name="externalLink.title"
                        control={control}
                        rules={{
                            validate: {
                                min: (value) => (value && value.length > 1) || 'must be at least 2 characters',
                            },
                        }}
                    />
                    {errors.externalLink?.title && (
                        <CustomizedFormErrorMessage text={errors.externalLink.title.message} />
                    )}
                </div>
                <div>
                    <div className={classes.inputTitle}>External Link target</div>
                    <Controller
                        render={({ field }) => (
                            <TextSearchInput
                                {...field}
                                isSearch={false}
                                placeholder=""
                                maxLength={1000}
                                handleClear={() => {
                                    setValue('externalLink.url', '');
                                }}
                            />
                        )}
                        name="externalLink.url"
                        control={control}
                        rules={{
                            validate: {
                                min: (value) => isValidUrl(value.trim()) || 'invalid link',
                            },
                        }}
                    />
                    {errors.externalLink?.url && <CustomizedFormErrorMessage text={errors.externalLink.url.message} />}
                </div>
            </div>

            <div className={classes.footer}>
                <div className={classes.container}>
                    <CustomizedButton size={'large'} color={'secondary'} onClick={handleCancel}>
                        Cancel
                    </CustomizedButton>

                    <CustomizedButton size={'large'} color={'primary'} type={'submit'}>
                        Add
                    </CustomizedButton>
                </div>
            </div>
        </div>
    );
};
